module.exports = __webpack_public_path__ + "media/images/icons/duotoneicons/Home/Wood#1-070ac10d800417020012f57a1a114c0c96301c09d1944d38e3a2cfdff5fe71fc.svg";